import { UPDATE_FACES_VALUES, UPDATE_FACES_VALUES_ERROR, UPDATE_FACES_VALUES_SUCCESS } from "./actionTypes";

export const updateFacesValues = (ws_pos, faces_values, token, history) => {
  return {
    type: UPDATE_FACES_VALUES,
    payload: { ws_pos, faces_values, token, history },
  };
};

export const updateFacesValuesSuccess = (message, faceValues) => {
  return {
    type: UPDATE_FACES_VALUES_SUCCESS,
    payload: { message, faceValues },
  };
};

export const updateFacesValuesError = (message) => {
  return {
    type: UPDATE_FACES_VALUES_ERROR,
    payload: message,
  };
};
